export const countryIsoMapping = {
  usa: "US",
  canada: "CA",
};

export const DEFAULT_COUNTRY = {
  name: "United States",
  iso: "US",
  iso3: "USA",
  international: false,
};

const BRAZIL_ISO = "BR";

export const TAXABLE_NUMBER_COUNTRY = [BRAZIL_ISO];

export const GLOBAL_COUNTRY_ISO = "GLOBAL";
export const GLOBAL_COUNTRY_NAME = "Global";

export const ALL_COUNTRIES_ISO = "ALL-COUNTRIES";
export const ALL_COUNTRIES_NAME = "All Countries";

export const GLOBAL_COUNTRY = {
  name: GLOBAL_COUNTRY_NAME,
  iso: GLOBAL_COUNTRY_ISO,
  label: "global",
  id: "global",
};
